import React from 'react'; 
import PropTypes from 'prop-types';
import Account, { AccountValidation } from '../../Account';

export default class AccountHolderInfo extends React.Component {
    render() {
        const p = this.props;
        if (!p.lookup) return null;
        return (
            <div>
                <Account name={p.name} disableMainInfo={p.disableMainInfo} 
                    title={p.lookup.title} customerType={p.customerType} {...p}/>
            </div>
        );
    }
}
AccountHolderInfo.propTypes = {
    lookup: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
    disableMainInfo: PropTypes.bool,
    customerType: PropTypes.string.isRequired,
};
export function AccountHolderInfoValidation(name, form) {
    return [...AccountValidation(name, form)];
}